import { render, staticRenderFns } from "./AffiliateEdit.vue?vue&type=template&id=5e05e60b&"
import script from "./AffiliateEdit.vue?vue&type=script&lang=js&"
export * from "./AffiliateEdit.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports